import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { BreadcrumbStyles } from './Breadcrumb.styled';

const Breadcrumb = ({ navItems }) => {
  return (
    <BreadcrumbStyles aria-label="breadcrumb">
      <ol className="breadcrumb">
        {navItems?.map((navItem, i) => {
          return (
            <li key={`breadcrumb-item-${i + 1}`} className="breadcrumb-item">
              {navItem.url ? (
                <Link href={navItem.url}>{navItem.text}</Link>
              ) : (
                navItem.text
              )}
            </li>
          );
        })}
      </ol>
    </BreadcrumbStyles>
  );
};

Breadcrumb.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

export default Breadcrumb;
